import React from 'react';

import './Switch.css';

const Switch = (props) => {
    const isSmall = props.isSmall || "";
    const isLarge = props.isLarge || ""

    return (
        <React.Fragment>
            <div className="btn-group">
                {
                    <button type="button" className={props.value ? `btn btn-primary ${isLarge} ${isSmall}` : `btn btn-default ${isLarge} ${isSmall}`} 
                        onClick={() => props.onChange(true)} 
                        disabled={props.disabled}
                    >
                        {
                            props.onlabel ? props.onlabel : "On"
                        }
                    </button>
                }
                {
                    <button type="button" className={props.value ? `btn btn-default ${isLarge} ${isSmall}` : `btn btn-primary ${isLarge} ${isSmall}`} 
                        onClick={() => props.onChange(false)} 
                        disabled={props.disabled}
                    >
                        {
                            props.offlabel ? props.offlabel : "Off"
                        }
                    </button>
                }
            </div>
        </React.Fragment>
    );
};

export default React.memo(Switch);